import { TagsInput as MantineTagsInput, TagsInputProps as MantineTagsInputProps } from '@mantine/core';

import inputStyles from '../styles/Input.module.css';

import { FC } from 'react';

type TagsInputProps = MantineTagsInputProps;

export const TagsInput: FC<TagsInputProps> = ({ ...props }) => {
    return (
        <MantineTagsInput
            classNames={{
                input: inputStyles.input,
                option: inputStyles.option,
                label: inputStyles.label,
                description: inputStyles.description,
                pill: inputStyles.pill,
                required: inputStyles.required,
            }}
            {...props}
        />
    );
};
